var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { PeekAutocomplete, PeekBox, PeekInput } from "@piiqtechnologies/ui-components";
import { useDebounce, useError, useGMBPlaces } from "@piiqtechnologies/ui-lib";
export const GMBPlaceSelector = (_a) => {
    var { field, form } = _a, props = __rest(_a, ["field", "form"]);
    const [getGMBPlaces, GMBPlacesResp, _GMBPlacesInProgress, GMBPlacesError] = useGMBPlaces();
    const { setError } = useError();
    const [searchText, setSearchText] = useState();
    const debouncedSearchKey = useDebounce(searchText, 700);
    useEffect(() => {
        getGMBPlaces({
            limit: !debouncedSearchKey ? 20 : undefined,
            search: debouncedSearchKey,
        });
    }, [debouncedSearchKey]);
    useEffect(() => {
        if (GMBPlacesError === null || GMBPlacesError === void 0 ? void 0 : GMBPlacesError.message) {
            setError(GMBPlacesError === null || GMBPlacesError === void 0 ? void 0 : GMBPlacesError.message);
        }
    }, [GMBPlacesError]);
    const handleGMBPlaceSelection = (_event, gmbPlace) => {
        //@ts-ignore
        form.setFieldValue(field.name, gmbPlace);
    };
    return (React.createElement(PeekBox, null,
        React.createElement(PeekAutocomplete, { freeSolo: false, popupIcon: null, sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, options: GMBPlacesResp || [], onChange: handleGMBPlaceSelection, getOptionLabel: ({ title }) => title, value: field.value, renderInput: (params) => (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: searchText, onChange: (e) => setSearchText(e.target.value) }), form: form }, params, props, { InputProps: Object.assign({}, params.InputProps) }))), isOptionEqualToValue: (option, value) => option.placeId === value.placeId })));
};
export default GMBPlaceSelector;
